import React from 'react';
import { StyledSpinner } from './Spinner.styled';
import MessagingSpinner from '../icon/icons/MessagingSpinner';
export const Spinner = (props) => {
    return (React.createElement(StyledSpinner, Object.assign({}, props),
        React.createElement(MessagingSpinner, null)));
};
//# sourceMappingURL=Spinner.js.map